import axios, { AxiosError } from "axios"
import { LIST_PATH, VIEW_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getViewsService = async () => {
  try {
    const result = await instance.get(VIEW_PATH + LIST_PATH)
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}
